import React from 'react';
import PropTypes from 'prop-types';

import api from 'api';
import { useRequest } from 'shared/hooks';
import { MAX_PAGE_SIZE } from 'utils/constants';
import Autocomplete from 'shared/components/forms/Autocomplete';

const NetworkSelect = ({ placeholder = '-- Network --', networkType, ...moreProps }) => {
  const { doRequest: fetchNetworks, data: networkData } = useRequest(
    api.getNetworkNames,
  );

  React.useEffect(() => {
    const params = { pageSize: MAX_PAGE_SIZE };
    if (networkType) params.networkType = networkType;
    fetchNetworks(params);
  }, [fetchNetworks, networkType]);

  const options = React.useMemo(
    () => networkData?.networks || [],
    [networkData],
  );

  return (
    <Autocomplete {...moreProps} placeholder={placeholder} options={options} />
  );
};

NetworkSelect.propTypes = {
  placeholder: PropTypes.string,
  networkType: PropTypes.string,
};

export default NetworkSelect;
